import moment from 'moment'

export function printBoxBarcode(param, LODOP, type) {
    const { printer = '', printerIndex = '', template = 'normal' } = JSON.parse(localStorage.getItem('printConfig')) || {}
    // 设置默认打印机
    LODOP.SET_PRINTER_INDEX(printerIndex)
    // 优先使用传入的配置
    const printType = type ? type : template
    return printType === 'normal' ? printBoxBarcodeNormal(param, LODOP) : printBoxBarcodeA5(param, LODOP)
}

// 普通标签打印 type:normal
export function printBoxBarcodeNormal(param, LODOP) {
    //设置纸张大小 以下样式按照原始大小为138*105绘制，后缩放
    LODOP.SET_PRINT_PAGESIZE(1, "100mm", "79mm", "");

    //设置标题行属性
    LODOP.ADD_PRINT_RECT("1mm", "1mm", "136mm", "8mm", 0, 1); //边框
    LODOP.ADD_PRINT_TEXTA("title", "2mm", "45mm", "70mm", "8mm", "STOCK LABEL SKF NK");
    LODOP.SET_PRINT_STYLEA("title", "FontSize", 18);
    LODOP.SET_PRINT_STYLEA("title", "Alignment", 2);
    LODOP.SET_PRINT_STYLEA("title", "Bold", 1);

    //供应商名称
    LODOP.ADD_PRINT_RECT("9mm", "1mm", "68mm", "17mm", 0, 1); //边框
    LODOP.ADD_PRINT_TEXTA("gyName", "11mm", "2mm", "68mm", "8mm", " From 供应商:");
    LODOP.ADD_PRINT_TEXTA("gyName", "17mm", "2mm", "68mm", "8mm", " " + (param.gyCode || ''));
    LODOP.SET_PRINT_STYLEA("gyName", "FontSize", 14);
    LODOP.SET_PRINT_STYLEA("gyName", "Alignment", 1);
    // 送货地点
    LODOP.ADD_PRINT_RECT("9mm", "69mm", "68mm", "17mm", 0, 1); //边框
    LODOP.ADD_PRINT_TEXTA("toAddress", "11mm", "70mm", "68mm", "8mm", " To 送货地点:(NKO)");
    LODOP.ADD_PRINT_TEXTA(
        "toAValue",
        "17mm",
        "70mm",
        "68mm",
        "8mm",
        " 北京南口斯凯孚铁路轴承有限公司"
    );
    LODOP.SET_PRINT_STYLEA("toAddress", "FontSize", 14);
    LODOP.SET_PRINT_STYLEA("toAddress", "Alignment", 1);

    //设置二维码 QRCode指定二维码格式
    LODOP.ADD_PRINT_RECT("26mm", "1mm", "45mm", "78mm", 0, 1); //边框
    LODOP.ADD_PRINT_BARCODE("38mm", "6mm", "44mm", "46mm", "QRCode", param.qrCode || '');
    // 标签打印时间
    LODOP.ADD_PRINT_TEXTA("bqdyDate", "83mm", "10mm", "40mm", "8mm", "标签打印时间");
    LODOP.ADD_PRINT_TEXTA("bqdyValue", "90mm", "8mm", "45mm", "8mm", param.dyDate || '');
    LODOP.SET_PRINT_STYLEA("bqdyDate", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("bqdyDate", "Alignment", 2);
    LODOP.SET_PRINT_STYLEA("bqdyValue", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("bqdyValue", "Alignment", 2);

    // 箱号+订单号+通道+物料型号+物料名称+每箱数量 top left width height
    LODOP.ADD_PRINT_RECT("26mm", "46mm", "91mm", "39mm", 0, 1); // 边框
    LODOP.ADD_PRINT_TEXTA("contentKey", "29mm", "47mm", "14mm", "6mm", "箱号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "29mm", "61mm", "75mm", "6mm", param.boxBarcode || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "35mm", "47mm", "19mm", "6mm", "订单号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "35mm", "66mm", "70mm", "6mm", param.orderNo || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "41mm", "47mm", "14mm", "6mm", "通道:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "41mm", "61mm", "75mm", "6mm", param.td || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "47mm", "47mm", "24mm", "6mm", "物料编号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "47mm", "71mm", "65mm", "6mm", param.wlType || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "53mm", "47mm", "24mm", "6mm", "物料名称:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "53mm", "71mm", "75mm", "6mm", param.wlName || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "59mm", "47mm", "24mm", "6mm", "每箱数量:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "59mm", "71mm", "65mm", "6mm", param.num || '');

    // 公差+批次+发货日期+围板类型+钢号+钢材炉号
    LODOP.ADD_PRINT_RECT("65mm", "46mm", "42mm", "39mm", 0, 1); // 边框
    LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", "47mm", "13mm", "6mm", "公差:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", "60mm", "32mm", "6mm", param.gc || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", "47mm", "13mm", "6mm", "批次:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", "60mm", "32mm", "6mm", param.pc || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", "47mm", "22mm", "6mm", "发货日期:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", "67mm", "25mm", "6mm", param.fhDate || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", "47mm", "22mm", "6mm", "围板类型:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", "69mm", "23mm", "6mm", param.wbType || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", "47mm", "13mm", "6mm", "钢号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", "60mm", "32mm", "6mm", param.gcNo || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", "47mm", "22mm", "6mm", "钢材炉号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", "69mm", "23mm", "6mm", param.gcLN || '');

    LODOP.ADD_PRINT_RECT("65mm", "88mm", "49mm", "39mm", 0, 1); // 边框
    LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", "89mm", "22mm", "6mm", "锻造炉号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", "111mm", "27mm", "6mm", param.dzNo || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", "89mm", "26mm", "6mm", "锻造供应商:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", "115mm", "23mm", "6mm", param.dzGY || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", "89mm", "26mm", "6mm", "供应商名称:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", "115mm", "23mm", "6mm", param.gyName || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", "89mm", "31mm", "6mm", "供应商追溯号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", "120mm", "18mm", "6mm", param.gyTrace || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", "89mm", "26mm", "6mm", "图纸版本号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", "115mm", "23mm", "6mm", param.tzVersion || '');
    LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", "89mm", "13mm", "6mm", "状态:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", "102mm", "36mm", "6mm", param.zt || '');

    // 项目名样式
    LODOP.SET_PRINT_STYLEA("contentKey", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("contentKey", "Alignment", 1);
    // 项目值样式
    LODOP.SET_PRINT_STYLEA("contentValue", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("contentValue", "Alignment", 1);
    LODOP.SET_PRINT_STYLEA("contentValue", "Bold", 1);

    LODOP.SET_PRINT_STYLE('FontName', '黑体')
    // 缩放以适应纸张大小
    // LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Page");
    LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", '72%');
    return LODOP;
}

// A5打印 type:A5
export function printBoxBarcodeA5(param, LODOP) {
    //设置纸张大小  以下样式按照原始大小为138*105绘制，后缩放
    var width = 148
    var height = 210

    const offsetX = 8
    // 设置打印内容缩放比例（可选）
    LODOP.SET_PRINT_PAGESIZE(2, width + "mm", height + "mm", "");

    //设置标题行属性
    LODOP.ADD_PRINT_RECT("1mm", `${1 + offsetX}mm`, "136mm", "8mm", 0, 1); //边框
    LODOP.ADD_PRINT_TEXTA("title", "2mm", `${25 + offsetX}mm`, "70mm", "8mm", "STOCK LABEL SKF NK");
    LODOP.SET_PRINT_STYLEA("title", "FontSize", 18);
    LODOP.SET_PRINT_STYLEA("title", "Alignment", 2);
    LODOP.SET_PRINT_STYLEA("title", "Bold", 1);

    //供应商名称
    LODOP.ADD_PRINT_RECT("9mm", `${1 + offsetX}mm`, "68mm", "17mm", 0, 1); //边框
    LODOP.ADD_PRINT_TEXTA("gyName", "11mm", `${2 + offsetX}mm`, "68mm", "8mm", " From 供应商:");
    LODOP.ADD_PRINT_TEXTA("gyName", "17mm", `${2 + offsetX}mm`, "68mm", "8mm", " " + param.gyCode);
    LODOP.SET_PRINT_STYLEA("gyName", "FontSize", 14);
    LODOP.SET_PRINT_STYLEA("gyName", "Alignment", 1);
    // 送货地点
    LODOP.ADD_PRINT_RECT("9mm", `${69 + offsetX}mm`, "68mm", "17mm", 0, 1); //边框
    LODOP.ADD_PRINT_TEXTA("toAddress", "11mm", `${70 + offsetX}mm`, "68mm", "8mm", " To 送货地点:(NKO)");
    LODOP.ADD_PRINT_TEXTA(
        "toAValue",
        "17mm",
        `${70 + offsetX}mm`,
        "68mm",
        "8mm",
        " 北京南口斯凯孚铁路轴承有限公司"
    );
    LODOP.SET_PRINT_STYLEA("toAddress", "FontSize", 14);
    LODOP.SET_PRINT_STYLEA("toAddress", "Alignment", 1);

    //设置二维码 QRCode指定二维码格式
    LODOP.ADD_PRINT_RECT("26mm", `${1 + offsetX}mm`, "45mm", "78mm", 0, 1); //边框
    LODOP.ADD_PRINT_BARCODE("38mm", `${6 + offsetX}mm`, "44mm", "46mm", "QRCode", param.qrCode);
    // 标签打印时间
    LODOP.ADD_PRINT_TEXTA("bqdyDate", "83mm", `${4 + offsetX}mm`, "30mm", "8mm", "标签打印时间");
    LODOP.ADD_PRINT_TEXTA("bqdyValue", "90mm", `${-6 + offsetX}mm`, "45mm", "8mm", param.dyDate);
    LODOP.SET_PRINT_STYLEA("bqdyDate", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("bqdyDate", "Alignment", 2);
    LODOP.SET_PRINT_STYLEA("bqdyValue", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("bqdyValue", "Alignment", 2);

    // 箱号+订单号+通道+物料型号+物料名称+每箱数量 top left width height
    LODOP.ADD_PRINT_RECT("26mm", `${46 + offsetX}mm`, "91mm", "39mm", 0, 1); // 边框
    LODOP.ADD_PRINT_TEXTA("contentKey", "29mm", `${47 + offsetX}mm`, "14mm", "6mm", "箱号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "29mm", `${61 + offsetX}mm`, "75mm", "6mm", param.boxBarcode);
    LODOP.ADD_PRINT_TEXTA("contentKey", "35mm", `${47 + offsetX}mm`, "19mm", "6mm", "订单号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "35mm", `${66 + offsetX}mm`, "70mm", "6mm", param.orderNo);
    LODOP.ADD_PRINT_TEXTA("contentKey", "41mm", `${47 + offsetX}mm`, "14mm", "6mm", "通道:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "41mm", `${61 + offsetX}mm`, "75mm", "6mm", param.td);
    LODOP.ADD_PRINT_TEXTA("contentKey", "47mm", `${47 + offsetX}mm`, "24mm", "6mm", "物料编号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "47mm", `${71 + offsetX}mm`, "65mm", "6mm", param.wlType);
    LODOP.ADD_PRINT_TEXTA("contentKey", "53mm", `${47 + offsetX}mm`, "24mm", "6mm", "物料名称:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "53mm", `${71 + offsetX}mm`, "75mm", "6mm", param.wlName);
    LODOP.ADD_PRINT_TEXTA("contentKey", "59mm", `${47 + offsetX}mm`, "24mm", "6mm", "每箱数量:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "59mm", `${71 + offsetX}mm`, "65mm", "6mm", param.num);

    // 公差+批次+发货日期+围板类型+钢号+钢材炉号
    LODOP.ADD_PRINT_RECT("65mm", `${46 + offsetX}mm`, "42mm", "39mm", 0, 1); // 边框
    LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", `${47 + offsetX}mm`, "13mm", "6mm", "公差:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", `${60 + offsetX}mm`, "32mm", "6mm", param.gc);
    LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", `${47 + offsetX}mm`, "13mm", "6mm", "批次:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", `${60 + offsetX}mm`, "32mm", "6mm", param.pc);
    LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", `${47 + offsetX}mm`, "22mm", "6mm", "发货日期:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", `${67 + offsetX}mm`, "25mm", "6mm", param.fhDate);
    LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", `${47 + offsetX}mm`, "22mm", "6mm", "围板类型:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", `${69 + offsetX}mm`, "23mm", "6mm", param.wbType);
    LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", `${47 + offsetX}mm`, "13mm", "6mm", "钢号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", `${60 + offsetX}mm`, "32mm", "6mm", param.gcNo);
    LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", `${47 + offsetX}mm`, "22mm", "6mm", "钢材炉号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", `${69 + offsetX}mm`, "23mm", "6mm", param.gcLN);

    LODOP.ADD_PRINT_RECT("65mm", `${88 + offsetX}mm`, "49mm", "39mm", 0, 1); // 边框
    LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", `${89 + offsetX}mm`, "22mm", "6mm", "锻造炉号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", `${110 + offsetX}mm`, "31mm", "6mm", param.dzNo);
    LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", `${89 + offsetX}mm`, "26mm", "6mm", "锻造供应商:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", `${114 + offsetX}mm`, "27mm", "6mm", param.dzGY);
    LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", `${89 + offsetX}mm`, "26mm", "6mm", "供应商名称:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", `${114 + offsetX}mm`, "27mm", "6mm", param.gyName);
    LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", `${89 + offsetX}mm`, "31mm", "6mm", "供应商追溯号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", `${118 + offsetX}mm`, "22mm", "6mm", param.gyTrace);
    LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", `${89 + offsetX}mm`, "26mm", "6mm", "图纸版本号:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", `${114 + offsetX}mm`, "23mm", "6mm", param.tzVersion);
    LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", `${89 + offsetX}mm`, "13mm", "6mm", "状态:");
    LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", `${102 + offsetX}mm`, "36mm", "6mm", param.zt);

    // 项目名样式
    LODOP.SET_PRINT_STYLEA("contentKey", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("contentKey", "Alignment", 1);
    // 项目值样式
    LODOP.SET_PRINT_STYLEA("contentValue", "FontSize", 12);
    LODOP.SET_PRINT_STYLEA("contentValue", "Alignment", 1);
    LODOP.SET_PRINT_STYLEA("contentValue", "Bold", 1);

    LODOP.SET_PRINT_STYLE('FontName', '黑体')
    // 缩放以适应纸张大小
    LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", '132%');
    return LODOP;
}

// 参数对照
const defaultFormat = {
    gyCode: 'verdorCode', // 供应商
    // qrCode: '', // 二维码拼接字符串
    // dyDate: '', // 标签打印时间
    boxBarcode: 'boxBarcode', // 箱码
    orderNo: 'orderCode', // 订单号
    td: 'whCode', // 通道
    wlType: 'matCode', // 物料编号
    wlName: 'matName', // 物料名称
    num: 'matQuan', // 每箱数量
    gc: 'matSpecs', // 公差
    pc: 'batchNo', // 批次
    fhDate: 'storeIssueTime', // 发货日期
    wbType: 'coamingType', // 围板类型
    gcNo: 'steelCode', // 钢号
    gcLN: 'heatNo', // 钢材炉号
    dzNo: 'forgeCode', // 锻造炉号
    dzGY: 'forgeSupplierCode', // 锻造供应商
    gyName: 'supplier', // 供应商名称
    gyTrace: 'traceability', // 供应商追溯号
    tzVersion: 'drawCode', // 图纸版本号
    zt: 'status', // 状态
    scDate: 'matProduceTime' // 生产日期
}

// 生成条码
export function createQrcode(data) {
    // qrCode生成规则 订单号+物料编号+箱数（默认1）+供应商+通道+总数量+供应商名称+生产日期+批次+状态+图纸版本号+供应商追溯号+箱号+锻造供应商+锻造炉号+钢材炉号+钢号+围板类型+发货日期+公差
    return (data.orderNo + ",;" + data.wlType + ",;1,;" + data.gyCode + ",;" + data.td + ",;" + data.num
        + ",;" + data.gyName + ",;" + data.scDate + ",;" + data.pc + ",;" + data.zt + ",;" + data.tzVersion + ",;" + data.gyTrace
        + ",;" + data.boxBarcode + ",;" + data.dzGY + ",;" + data.dzNo + ",;" + data.gcLN + ",;" + data.gcNo + ",;" + data.wbType
        + ",;" + data.fhDate + ",;" + data.gc).replaceAll("undefined", "");
}

// 参数统一
export function printParamsFormat(params, customFormat = {}) {
    const format = {
        ...defaultFormat,
        ...customFormat
    }
    const data = {}
    for (var key in format) {
        data[key] = params[format[key]] || ''
    }
    // 时间特殊处理
    data.fhDate = data.fhDate ? moment(data.fhDate).format("YYYYMMDD") : '' // 发货日期
    data.scDate = data.scDate ? moment(data.scDate).format("YYYY-MM-DD") : '' // 生产日期
    data.dyDate = moment().format("YYYY-MM-DD HH:mm:ss") // 打印日期
    data.qrCode = createQrcode(data)
    return data
}
